/**
 * @description client请求的封装：封装一些异常处理等
 */

import axios from 'axios';
import LogicError from './LogicError';

const APP_JSON_CONTENT_TYPE = 'application/json';
const DEFAULT_RESPONSE = {
  data: {
    data: {},
    code: 400,
    message: 'unknow client error',
  },
  status: 400,
  statusText: 'client error',
};

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */

const ApiClient = class {
  logPerformance() {
  }
  request(
    method,
    path,
    {
      params, data: _data, formData, timeout = 20000, withCredentials = false,
    } = {},
    headers
  ) {
    const options = {
      method,
      withCredentials,
      timeout,
      responseType: 'json',
      headers: {
        'Content-Type': `${APP_JSON_CONTENT_TYPE}; charset=utf-8`,
        Accept: APP_JSON_CONTENT_TYPE,
      },
      data: {},
    };
    // if (method === 'get') delete options.data;

    if (headers) {
      options.headers = Object.assign(options.headers, headers);
    } else if (headers === false) {
      options.headers = null;
      options.transformRequest = (data, headers) => {
        delete headers.common.Authorization;
        return data;
      };
    }

    if (_data) {
      options.data = JSON.stringify(_data, (key, value) => {
        if (value == null) {
          return undefined;
        }
        return value;
      });
    }

    if (formData) {
      options.data = formData;
    }

    let url = path;
    if (params) {
      url += Object.keys(params).filter(key => params[key] != null)
        .reduce((accPara, key) => {
          let acc = accPara;
          if (Object.prototype.toString.call(params[key]) === '[object Array]') { // array
            acc += `${key}=${JSON.stringify(params[key])}&`;
          } else {
            acc += `${key}=${params[key]}&`;
          }
          return acc;
        }, '?');
      url = url.slice(0, url.length - 1);
    }
    options.url = url;
    // 默认值：
    // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
    // xsrfCookieName: 'XSRF-TOKEN', // default
    // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    // xsrfHeaderName: 'X-XSRF-TOKEN', // default

    return axios.request(options)
      .then(response => new Promise((resolve, reject) => {
        const {
          data: {
            data, code, msg, status,
          },
        } = response;
        this.logPerformance();
        // console.log(`code:${code};msg:${msg};data:${data}`)
        if (code === undefined) {
          return resolve(response.data);
        }
        if (code === 0 || code === '0') {
          return resolve({ data, code, msg });
        }
        return reject({ data, code, msg });
      }))
      .catch(error => new Promise((resolve, reject) => {
        this.logPerformance();
        if (error instanceof LogicError || error.code || !error.response.data) {
          return reject(error);
        }

        console.log('ApiClient: catch error: ', error);
        const { response: { data: { data, code, msg }, status, statusText } = DEFAULT_RESPONSE } = error;
        if (!error.response) {
          console.error(`ApiClient send request to '${url}' failed, backend response message: `, error.message);
          return reject(LogicError.create(status, code, msg || `Request ${url} failed, code=${code}, message: ${error.message || msg}`, data));
        }

        if ([401, 403, 404].indexOf(status) !== -1) {
          return reject(LogicError.create(status, code, msg || `Request ${url} failed, code=${code}, message=${msg || error.message || statusText}`, data));
        } if (status === 418) {
          return reject(LogicError.create(status, code, msg || 'Unexpected http status 418 when fetching via server side!', data,));
        } if (status >= 400) {
          return reject(LogicError.create(status, code, msg || `Request ${url} failed, code=${code}, message=${msg}`, data));
        }
        return reject(LogicError.create(status, code, msg || `Request ${url} failed, code=${code}, message=${msg}`, data));
      }));
  }

  get(path, {
    params, data, timeout, withCredentials,
  } = {}, headers) {
    return this.request('get', path, {
      params, data, timeout, withCredentials,
    }, headers);
  }

  post(path, {
    params, data, timeout, withCredentials,
  } = {}, headers) {
    return this.request('post', path, {
      params, data, timeout, withCredentials,
    }, headers);
  }

  del(path, {
    params, data, timeout, withCredentials,
  } = {}, headers) {
    return this.request('delete', path, {
      params, data, timeout, withCredentials,
    }, headers);
  }

  put(path, {
    params, data, timeout, withCredentials,
  } = {}, headers) {
    return this.request('put', path, {
      params, data, timeout, withCredentials,
    }, headers);
  }

  upload(path, {
    params, data, timeout, withCredentials,
  } = {}, headers) {
        const formData = new FormData(); // eslint-disable-line
    Object.keys(data).forEach(v => formData.append(v, data[v]));
    return this.request('post', path, {
      params, formData, timeout, withCredentials,
    }, Object.assign({}, headers, {
      'Content-Type': 'multipart/form-data',
    }));
  }
};

export default ApiClient;
